import * as loadingState from '@dragonfruit/constants/loadingState';

export const SAVE_PURCHASE = 'SAVE_PURCHASE';

export const FETCH_PAYMENT_RECEIPT = 'FETCH_PAYMENT_RECEIPT';
export const FETCH_PAYNOW_PAYMENT_RECEIPT = 'FETCH_PAYNOW_PAYMENT_RECEIPT';
export const FETCH_PAYMENT_RECEIPT_SUCCESS = 'FETCH_PAYMENT_RECEIPT_SUCCESS';
export const FETCH_PAYMENT_RECEIPT_ERROR = 'FETCH_PAYMENT_RECEIPT_ERROR';
export const FETCH_BANK_TRANSFER_PAYMENT_RECEIPT =
  'FETCH_BANK_TRANSFER_PAYMENT_RECEIPT';

export const FETCH_PAYMENT_RECEIPT_FOR_OFFLINE_SUCCESS =
  'FETCH_PAYMENT_RECEIPT_FOR_OFFLINE_SUCCESS';

export const savePurchase = ({ orderNumber }) => ({
  type: SAVE_PURCHASE,
  payload: {
    orderNumber,
  },
});

export const fetchPaymentReceipt = receiptNumber => ({
  type: FETCH_PAYMENT_RECEIPT,
  payload: {
    receiptNumber,
  },
});

export const fetchPayNowPaymentReceipt = receiptNumber => ({
  type: FETCH_PAYNOW_PAYMENT_RECEIPT,
  payload: {
    receiptNumber,
  },
});

export const fetchBankTransferPaymentReceipt = receiptNumber => ({
  type: FETCH_BANK_TRANSFER_PAYMENT_RECEIPT,
  payload: {
    receiptNumber,
  },
});

export const fetchPaymentReceiptSuccess = orderDetail => ({
  type: FETCH_PAYMENT_RECEIPT_SUCCESS,
  payload: {
    orderDetail,
  },
});

export const fetchPaymentReceiptError = errorCode => ({
  type: FETCH_PAYMENT_RECEIPT_ERROR,
  payload: {
    errorCode,
  },
});

export const fetchPaymentReceiptForOfflineSuccess = planDetail => ({
  type: FETCH_PAYMENT_RECEIPT_FOR_OFFLINE_SUCCESS,
  payload: {
    planDetail,
  },
});

const INIT_STATE = {
  status: loadingState.EMPTY,
  orderNumber: '',
  detail: {},
};

const reducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_PURCHASE:
      return {
        ...state,
        orderNumber: action.payload.orderNumber,
      };
    case FETCH_PAYMENT_RECEIPT:
      return {
        ...state,
        status: loadingState.LOADING,
      };
    case FETCH_PAYMENT_RECEIPT_SUCCESS:
      return {
        ...state,
        status: loadingState.READY,
        detail: action.payload.orderDetail,
      };

    case FETCH_PAYMENT_RECEIPT_FOR_OFFLINE_SUCCESS:
      return {
        ...state,
        status: loadingState.READY,
        detail: action.payload.planDetail,
      };

    case FETCH_PAYMENT_RECEIPT_ERROR:
      return {
        ...state,
        status: loadingState.ERROR,
        errorCode: action.payload.errorCode,
      };
    default:
      return state;
  }
};

export default reducer;

export const getNewebWriteoff = state => state.paymentReceipt.writeoffNumber;
export const getOrderNumber = state => state.paymentReceipt.orderNumber;
export const getPaymentReceiptDetail = state => state.paymentReceipt.detail;



// WEBPACK FOOTER //
// ./app/redux/purchase/paymentReceipt.js